import { render, staticRenderFns } from "./PsrMenuPatientDoctor.vue?vue&type=template&id=220e32ed&scoped=true&"
import script from "./PsrMenuPatientDoctor.vue?vue&type=script&lang=js&"
export * from "./PsrMenuPatientDoctor.vue?vue&type=script&lang=js&"
import style0 from "./PsrMenuPatientDoctor.vue?vue&type=style&index=0&id=220e32ed&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "220e32ed",
  null
  
)

export default component.exports